<template>
    <v-container>
        <p class="text-left mt-2 mb-0 ml-5">{{ $t("page.events.pricing.coupon-discount-description")}}</p>
        <v-data-table 
            :headers="headersCD" 
            :items="cdItems" 
            class="elevation-1 mt-0"
            :footer-props="{
                'items-per-page-text': $t('dataTable.rowsPerPageText'),
                'items-per-page-all-text': $t('dataTable.rowsPerPageAllText')
            }"
            :no-data-text="$t('dataTable.noDataText')"
            :headerProps="{
                'sort-by-text': $t('dataTable.sortByText')
            }"
        >
            <template v-slot:top>
                <v-toolbar flat color="white">
                    <v-dialog v-model="dialogCD" max-width="600px" persistent>
                        <template v-slot:activator="{ on }">
                            <v-btn color="primary" dark class="mb-2 primary" v-on="on" @click="openModalCD()" small>
                                <v-icon left dark>fa-plus</v-icon>
                                {{ $t('page.events.pricing.coupon-discount-add') }}
                            </v-btn>
                        </template>
                        <v-card>
                            <v-card-title>
                                <span class="headline">{{ $t('page.events.pricing.coupon-discount-title') }}</span>
                            </v-card-title>
                            <v-card-text>
                                <v-form ref="formCD">
                                    <v-row class="mt-2">
                                        <v-col cols="12">
                                            <v-text-field 
                                                outlined dense 
                                                :label="$t('page.events.pricing.coupon-discount-name')" 
                                                :rules="nameRequired"
                                                maxLength="40"
                                                v-model="cd.name"
                                            ></v-text-field>
                                        </v-col>
                                        <v-col cols="12">
                                            <v-text-field 
                                                outlined dense 
                                                :label="$t('page.events.pricing.coupon-discount-code')" 
                                                v-model="cd.code" persistent-hint
                                                :rules="codeRequired"
                                                :hint="$t('page.events.pricing.code-hint')"
                                            ></v-text-field>
                                        </v-col>
                                        <v-col cols="12">
                                            <v-select 
                                                ref="typeCoupon"
                                                dense outlined 
                                                :items="typeCouponItemsLanguages" 
                                                item-value="id" 
                                                item-text="name"
                                                :label="$t('page.events.pricing.coupon-discount-type')"
                                                v-model="cd.type" 
                                                @change="onDiscountTypeChange"
                                                persistent-hint
                                                :rules="typeRequired"
                                                :hint="$t('page.events.pricing.percentage-hint')"
                                                :no-data-text="$t('common.no_data')"
                                            >
                                                <template v-slot:selection="{ item }">
                                                    {{ $t(`page.events.pricing.${item.description}`)}}
                                                </template>
                                            </v-select>
                                        </v-col>
                                        <v-col cols="12">
                                            <v-text-field 
                                                ref="valueCoupon"
                                                outlined dense 
                                                :label="$t('page.events.pricing.coupon-discount-value')" 
                                                v-model="cd.value" 
                                                persistent-hint
                                                :rules="[
                                                    (v) => $inputRules({ value: v }, ammountInputRule) || $t('page.events.pricing.value-invalid')
                                                ]"
                                            ></v-text-field>
                                        </v-col>
                                        <v-col cols="12">
                                            <v-text-field 
                                                outlined dense 
                                                :label="$t('page.events.pricing.coupon-discount-upcoupon')" 
                                                v-model="cd.upcoupon" persistent-hint
                                                :rules="couponUPRules"
                                                :hint="$t('page.events.pricing.upcoupon-hint')"
                                                @keypress="restrictCharsUPC"
                                                :maxlength="9"
                                            ></v-text-field>
                                        </v-col>
                                        <v-col cols="12">
                                            <v-text-field 
                                                outlined dense 
                                                :label="$t('page.events.pricing.coupon-discount-upcustomer')" 
                                                v-model="cd.upcustomer" persistent-hint
                                                :rules="couponUPCustomerRules"
                                                :hint="$t('page.events.pricing.upcustomer-hint')"
                                                @keypress="restrictCharsUPC"
                                                :maxlength="9"
                                            ></v-text-field>
                                        </v-col>
                                        <v-col cols="12">
                                            <v-select 
                                                dense outlined 
                                                :items="statusCouponItemsLanguages" 
                                                item-value="id" item-text="name"
                                                :label="$t('page.events.pricing.coupon-discount-status')"
                                                :rules="statusRequired"
                                                v-model="cd.status"
                                                :no-data-text="$t('common.no_data')"
                                            ></v-select>
                                        </v-col>
                                        <v-col cols="12">
                                            <v-radio-group v-model="optionEvents" row :rules="optionEventsRule">
                                                <v-radio :label="$t('page.events.pricing.specific-events')" value="1" class="mb-label-radio"></v-radio>
                                                <v-radio :label="$t('page.events.pricing.all-events')" value="2" class="mb-label-radio"></v-radio>
                                            </v-radio-group>
                                        </v-col>
                                        <v-col cols="12" v-if="optionEvents == 1">
                                            <v-select
                                                :items="listEvents"
                                                v-model="listEventsSelection"
                                                dense outlined multiple
                                                :label="$t('common.form.events')"
                                                item-value="id"
                                                item-text="name"
                                                :rules="eventSelectionRule"
                                                :no-data-text="$t('common.no_data')"
                                            ></v-select>
                                        </v-col>
                                    </v-row>
                                </v-form>
                            </v-card-text>

                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn color="darken-1" dark small @click="closeDialogCD()">{{ $t('page.events.pricing.coupon-discount-cancel') }}</v-btn>
                                <v-btn color="darken-1" dark small @click="saveCD" :disabled="!formCDIsValid">{{ $t('page.events.pricing.coupon-discount-save') }}</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                </v-toolbar>
            </template>
            <template v-slot:[`item.couponTypeName`]="{ item }">
                {{ $t(`page.events.pricing.${item.couponTypeName.toLowerCase()}`) }}
            </template>
            <template v-slot:[`item.couponStatusName`]="{ item }">
                {{ $t(`common.${item.couponStatusName.toLowerCase()}`) }}
            </template>
            <template v-slot:[`item.actions`]="{ item }">
                <v-icon small class="mr-2" @click="editItemCD(item)">mdi-pencil</v-icon>
                <v-icon small @click="confirmDeleteCD(item)">mdi-delete</v-icon>
            </template>
        </v-data-table>
        <SGSNotificationConfirm v-if="dialogNotificationCoupon" :notificationMessage="$t('common.confirm-delete')" @cancel="dialogNotificationCoupon=false;" @agree="deleteItemCD" type='warning'/>
        <SGSNotificationAlert v-if="errorDialog" :notificationMessage="$t(`page.events.pricing.${errorDialogMessage}`)" @cancel="closeAlert" type='error'/>
    </v-container>
</template>

<script>
import { apiCalls } from "@/mixins/apiCalls.js";
import SGSNotificationConfirm from "@/components/custom/notification/NotificationConfirm.vue";
import SGSNotificationAlert from "@/components/custom/notification/NotificationAlert.vue";

export default {
    mixins: [apiCalls],
    components: {SGSNotificationConfirm,SGSNotificationAlert},
    data() {
        return {
            cdItems: [],
            dialogCD: false,
            cd: {
                name: '',
                code: '',
                type: 13,
                value: null,
                status: null,
                upcustomer: null,
                upcoupon: null
            },
            typeCoupon: 13,
            typeCouponItems: [],
            statusCouponItems: [],
            optionEvents: null,
            listEvents: [],
            listEventsSelection: [],
            errorDialog: false,
            errorDialogMessage: '',
            dialogNotificationCoupon: false,
            reopenDialog: false
        };
    },
    computed: {
        headersCD: function(){
            return [
                {
                    text: this.$t("page.events.pricing.coupon-discount-name"),
                    value: 'name'
                },
                {
                    text: this.$t("page.events.pricing.coupon-discount-code"),
                    value: 'code'
                },
                {
                    text: this.$t("page.events.pricing.coupon-discount-type"),
                    value: 'couponTypeName'
                },
                {
                    text: this.$t("page.events.pricing.coupon-discount-value"),
                    value: 'valueLabel'
                },
                {
                    text: this.$t("page.events.pricing.coupon-discount-upcoupon"),
                    value: 'usesPerCoupon'
                },
                {
                    text: this.$t("page.events.pricing.coupon-discount-upcustomer"),
                    value: 'usesPerCustomer'
                },
                {
                    text: this.$t("page.events.pricing.coupon-discount-status"),
                    value: 'couponStatusName'
                },
                {
                    text: this.$t("page.events.pricing.coupon-discount-action"),
                    value: 'actions',
                    sortable:false
                }
            ]
        },
        formCDIsValid() {
            return (
                (this.cd.name || "").length > 0 && (this.cd.code || "").length > 0 && 
                this.cd.status && this.typeCoupon && this.cd.value && 
                this.optionEvents
            );
        },
        nameRequired: function() {
            const regABC = new RegExp('[a-zA-Z0-9 ]+');
            return [ 
                v => !!v || this.$t("page.events.pricing.coupon-discount-name-required"),
                (v) => {
                    const auxV = v ? v.toString() : "";
                    const resultABC = auxV.split(regABC).filter(el => el != "");
                    return !(resultABC.length > 0) || this.$t("page.events.pricing.name-invalid");
                }
            ];
        },
        codeRequired() {

            const regABC = new RegExp('[a-zA-Z0-9 ]+');
            return [
                (v) => {

                    if((v || '').length == 0) {
                        return this.$t("page.events.pricing.coupon-discount-code-required");
                    }

                    const auxV = v ? v.toString() : "";
                    const resultABC = auxV.split(regABC).filter(el => el != "");

                    if(resultABC.length > 0 || (v || '').length > 40) {
                        return this.$t("page.events.pricing.code-invalid");
                    }

                    return true;
                }
            ];
        },
        typeRequired: function(){
            return [ v => !!v || this.$t("page.events.pricing.coupon-discount-type-required") ];
        },
        couponUPRules() {
            const regInt = new RegExp('[0-9]+');
            return [ 
                (v) => {
                    const auxV = v ? v.toString() : "";
                    const resultInt = auxV.split(regInt).filter(el => el != "");
                    return (
                        (v || "").toString().length == 0 || 
                        ((v || "").toString().length > 0 && !(resultInt.length > 0)) || 
                        this.$t("page.events.pricing.uses-per-coupon-invalid")
                    );
                },
                (v) => {
                    const value = parseFloat(v);
                    const auxV = v ? v.toString() : "";
                    return (
                        (v || "").toString().length == 0 || 
                        (auxV.length > 0 && value >= 0 && value < 1000000000) || 
                        this.$t("page.events.pricing.uses-pc-range-invalid")
                    );
                }
            ];
        },
        couponUPCustomerRules() {
            const regInt = new RegExp('[0-9]+');
            return [ 
                (v) => {
                    const auxV = v ? v.toString() : "";
                    const resultInt = auxV.split(regInt).filter(el => el != "");
                    return (
                        (v || "").toString().length == 0 || 
                        (auxV.length > 0 && !(resultInt.length > 0)) || 
                        this.$t("page.events.pricing.uses-per-customer-invalid")
                    );
                },
                (v) => {
                    const value = parseFloat(v);
                    const auxV = v ? v.toString() : "";
                    return (
                        (v || "").toString().length == 0 || 
                        (auxV.length > 0 && value >= 0 && value < 1000000000) || 
                        this.$t("page.events.pricing.uses-pcu-range-invalid")
                    );
                }
            ];
        },
        statusRequired: function(){
            return [ v => !!v || this.$t("page.events.pricing.coupon-discount-status-required") ];
        },
        optionEventsRule() {
            return [ 
                v => !!v || this.$t("page.events.pricing.option-required")
            ];
        },
        eventSelectionRule() {
            return [ 
                v => (v || []).length > 0 || this.$t("page.events.pricing.null_eventsId")
            ];
        },
        discountAmmount() {
            return this.cd.value;
        },
        discountType() {
            return this.cd.type;
        },
        valueRules() {
            return [
                (v) => this.$inputRules({ value: v }, 'doubleMySQL') || this.$t('page.events.pricing.value-invalid'),
                (v) => {
                    return this.$refs.typeCoupon.value != 13 || this.$inputRules({ value: v }, 'percentage') || this.$t('page.events.pricing.value-percentage-invalid');
                }
            ];
        },
        ammountInputRule(){
            return this.discountType == 13 ? 'percentage' : 'doubleMySQL';
        },
        typeCouponItemsLanguages() {
            return this.typeCouponItems.map((item) => {
                return {
                    ...item, 
                    name: this.$t(`page.events.pricing.${item.name.toLowerCase()}`)
                };
            })
        },
        statusCouponItemsLanguages() {
            return this.statusCouponItems.map((item) => {
                return {
                    ...item,
                    name: this.$t(`common.${item.name.toLowerCase()}`)
                };
            });
        }
    },
    methods: {
        openModalCD() {
            this.titleEventTaxes = this.$t('common.form.add_event_taxes');
            this.dialogCD = true;
            if(this.$refs.formCD) {
                this.$refs.formCD.resetValidation();
                this.cleanCD();
                this.cd.value = '';
                this.cd.id = null;
                this.typeCoupon = 13;
            }
        },
        restrictChars($event) {
            if (
                    $event.charCode === 0 || 
                    ((this.cd.value || "").length > 0 && (this.cd.value || "").length < 7 && !(this.cd.value || "").includes(".") && $event.charCode === 46) || 
                    ((this.cd.value || "").length < 6 && !(this.cd.value || "").includes(".") && /\d/.test(String.fromCharCode($event.charCode))) || 
                    ((this.cd.value || "").includes(".") && (this.cd.value || "").split(".")[1].length < 2 && /\d/.test(String.fromCharCode($event.charCode)))
                ) {
                return true
            } else {
                $event.preventDefault();
            }
        },
        restrictCharsUPC($event) {
            if ($event.charCode === 0 || /\d/.test(String.fromCharCode($event.charCode))) {
                return true
            } else {
                $event.preventDefault();
            }
        },
        async saveCD(){
            if(this.$refs.formCD.validate()){
                let data = {
                    "name": this.cd.name,
                    "code": this.cd.code,
                    "value": this.cd.value,
                    "status": this.cd.status,
                    "type": this.cd.type,
                    "usesPerCoupon": this.cd.upcoupon,
                    "usesPerCustomer": this.cd.upcustomer,
                    "userId": this.userId,
                    "option": this.optionEvents,
                };
                if(this.optionEvents == 1) data.eventsId = this.listEventsSelection;
                let method = "post";
                if(this.cd.id){
                    data.id = this.cd.id;
                    method = "put";
                }  
                const response = await this.api(method, "/api/v1/promoter/coupon", data);           
                if(response && response.success == 1){
                    this.loadCoupons();
                    this.dialogCD = false;
                } else if(response && !response.success) {
                    if(Array.isArray(response.message)) {
                        this.errorDialogMessage = response.message[0];
                    } else if(Array.isArray(response.error)) {
                        this.errorDialogMessage = response.error[0];
                    } else if(response.error && Array.isArray(response.error.message)) {
                        this.errorDialogMessage = response.error.message[0];
                    } else {
                        this.errorDialogMessage = 'error-general';
                    }
                    this.errorDialog = true;
                    this.reopenDialog = true;
                    this.dialogCD = false;
                } else {
                        this.errorDialog = true;
                    this.dialogCD = false;
                    this.reopenDialog = true;
                        this.errorDialogMessage = 'error-general';
                }
            }
        },
        closeAlert(){
            this.errorDialog=false;
            if(this.reopenDialog){
                this.dialogCD = true;
            }
        },
        async loadCoupons(){
            await this.loadUser();
            const response = await this.api("get", "/api/v1/promoter/coupon/"+this.userId)
            if(response.success == 1){
                 this.cdItems = response.message.map((el) => {
                     return {
                        id: el.eventCouponId,
                        name: el.name,
                        code: el.code,
                        usesPerCoupon: el.usesPerCoupon,
                        usesPerCustomer: el.usesPerCustomer,
                        idCouponStatus: el.idCouponStatus,
                        couponStatusName: el.couponStatusName,
                        couponStatusCode: el.couponStatusCode,
                        idCouponType: el.idCouponType,
                        couponTypeName: el.couponTypeName,
                        couponTypeCode: el.couponTypeCode,
                        valueLabel: el.couponTypeName == 'FixedAmount' ? `$${el.value}` : `${el.value}%`,
                        value: el.value,
                        events: el.events
                     }
                 });
            }
        },
        async editItemCD(item) {
            // Update cd object with item properties
            Object.assign(this.cd, {
                name: item.name,
                code: item.code, 
                type: item.idCouponType,
                value: item.value,
                status: item.idCouponStatus,
                upcustomer: item.usesPerCustomer,
                upcoupon: item.usesPerCoupon,
                id: item.id
            });

            this.typeCoupon = item.idCouponType;
            this.optionEvents = item.events.length ? '1' : '2';
            this.listEventsSelection = item.events.map(({fkEventId}) => fkEventId);           

            this.dialogCD = true;
        },
        async deleteItemCD() {
            const response = await this.api(
                "delete",
                "/api/v1/promoter/coupon/"+ this.userId +"/" + this.itemCouponSel.id
            );
            if(response.success) {
                this.loadCoupons();
            }
            this.dialogNotificationCoupon = false;
            this.itemCouponSel = null;
        },
        async confirmDeleteCD(item){
            this.dialogNotificationCoupon = true;
            this.itemCouponSel = item;
        },
        async loadStatusCoupon(){
            const response = await this.api("get", "/api/v1/promoter/couponStatus")
            if(response.success == 1){
                 this.statusCouponItems = response.message.map((el) => {
                     return {
                         id: el.id,
                         name: el.name
                     }
                 });
            }
        },
        async loadTypeCoupon(){
            const response = await this.api("get", "/api/v1/promoter/couponTypes");
            if(response.success == 1){
                this.typeCouponItems = response.message;
            }
        },
        async loadEvents() {
            const response = await this.api("get", "/api/v1/users/current/getUserEventList/curE");
            if(response.success) {
                this.listEvents = response.message;
            }
        },
        async loadUser(){
            const response = await this.api("get", "/api/v1/users/current")
            if(response.success == 1){
                this.userId = response.message.id;
            
                const responseEvent = await this.api("get", "/api/v1/promoter/isEventOwner/"+this.$route.params.id)
                if(!responseEvent){
                    window.location.href = `${process.env.VUE_APP_ROOT}/login?message=You20are%20logged%20out!`;
                }

            }
        },
        onDiscountTypeChange()
        {
            // Only reset on a manual type change; editItemCD loads type and value together
            this.cd.value = 0;
        },
        closeDialogCD()
        {
            this.dialogCD =false;
        },
        cleanCD(){
            this.cd = {
                name: '',
                code: '',
                type: 13,
                value: null,
                status: null,
                upcustomer: null,
                upcoupon: null
            };
            this.typeCoupon = 13;
        }
    },
    created() {
        this.loadCoupons();
        this.loadStatusCoupon();
        this.loadTypeCoupon();
        this.loadEvents();
    },
    watch: {
        optionEvents(val) {
            if(val == 2) {
                this.listEventsSelection = [];
            }
        },
        discountAmmount(val)
        {
            if(!val || val == undefined) return;

            /**
             * Mysql Only allows 2 digits for floats
             */
            const parsedAmmount = parseFloat(val, 2);

            /**
             * 0 is he minimun accepted ammount
             */
            if(parsedAmmount < 0)
            {
                this.$nextTick(()=>{
                    this.cd.value = 0;
                })
                return;
            }
        }
    }
}
</script>